export const patentByYearChart = {
    xAxis: 'Year',
    yAxis: 'Number of Patent Applications',
    legend: 'Company Name',

    csvColumn1: 'Company Name',
    csvColumn2: 'Year',
    csvColumn3: 'Patent Count'
}
